import { Component } from '@angular/core';
import { ExtraFieldType } from '../extra-field-type';

@Component({
  selector: 'formly-field-group',
  template: `
		<formly [form]="form" [fields]="field.data?.fields" [model]="model" [classNames]="to.fieldGroupWrapperClass" [inline]="to.inline"></formly>
	`
})
export class FormlyFieldGroupComponent extends ExtraFieldType { }